module.exports = __webpack_public_path__ + "img/e.249ac072.jpg";